import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import MyDataTable from "../../../component/MyDataTable";
import { Link } from "react-router-dom";
import { openSignUrl } from "../../../utils/HelperFunction";
import httpRequest from "../../../utils/Http";
import { UploadFileToS3 } from "../../../utils/S3File";
import { toast } from "react-toastify";

export const UploadAggrementCopy = ({ entity_id, entity_type }) => {
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({ entity_id, entity_type });
  const [reloadList, setReload] = useState(true);

  const handleStartDateChange = (date) => {
    setFormData({
      ...formData,
      start_date: date,
    });
  };

  const handleEndDateChange = (date) => {
    setFormData({
      ...formData,
      end_date: date,
    });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const columns = [
    {
      name: "SNo.",
      selector: (_, index) => index + 1,
    },
    {
      name: "Start Date",
      selector: (row) => row.start_date,
    },
    {
      name: "End Date",
      selector: (row) => row.end_date,
    },
    {
      name: "Download",
      selector: (row) => (
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            openSignUrl(row.aggrement_file);
          }}
          rel="noopener noreferrer"
          className="btn btn-sm btn-outline-primary"
          title="Download Agreement"
        >
          <i className="fa fa-download"></i>
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
    {
      name: "Uploaded By",
      selector: (row) => row.agent_detail?.name || "-",
    },
    {
      name: "Uploaded Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
    },
  ];

  const validateFrom = (values) => {
    const errors = {};
    if (!values.start_date) {
      errors.start_date = "Start Date is required";
    }
    if (!values.end_date) {
      errors.end_date = "End Date is required";
    }
    if (!values.aggrement_tmp_file) {
      errors.aggrement_file = "Aggrement File is required";
    }

    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        let formData1 = {};
        formData1 = formData;
        if (formData.aggrement_tmp_file) {
          const aggrement_file = await UploadFileToS3(
            "docFile",
            formData.aggrement_tmp_file,
          );
          formData1.aggrement_file = aggrement_file;
        }

        const data = await httpRequest(
          "uploadaggrementcopy",
          formData1,
          "POST",
        );

        setSubmit(false);
        if (data.status === true && data.message) {
          toast.success(data.message);
          setReload(true);
          document.getElementById("aggrementform").reset();
          setFormData({ entity_id, entity_type });
          // navigate("/sfdetails/" + data.data["id"] + "?tab=documents");
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);
  return (
    <div className="aggrement-copy-shell">
      <div className="card aggrement-copy-card">
        <div className="card-header aggrement-copy-header">
          <h3 className="card-title mb-0">Agreement Copy</h3>
        </div>

        <form
          id="aggrementform"
          onSubmit={onSubmitHandler}
          className="card-body aggrement-copy-form"
        >
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">
                  Start Date <span className="text-danger">*</span>
                </label>
                <DatePicker
                  className={`form-control ${formErrors.start_date ? "is-invalid" : ""}`}
                  placeholderText="Select start date"
                  selected={formData.start_date}
                  onChange={handleStartDateChange}
                  dateFormat="dd/MM/yyyy"
                  isClearable
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={15}
                  showMonthDropdown
                />
                {formErrors.start_date && (
                  <div className="invalid-feedback d-block">
                    {formErrors.start_date}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">
                  End Date <span className="text-danger">*</span>
                </label>
                <DatePicker
                  className={`form-control ${formErrors.end_date ? "is-invalid" : ""}`}
                  placeholderText="Select end date"
                  selected={formData.end_date}
                  onChange={handleEndDateChange}
                  dateFormat="dd/MM/yyyy"
                  isClearable
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={15}
                  showMonthDropdown
                />
                {formErrors.end_date && (
                  <div className="invalid-feedback d-block">
                    {formErrors.end_date}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">
                  Agreement File <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  className={`form-control ${formErrors.aggrement_file ? "is-invalid" : ""}`}
                  id="aggrement_file"
                  name="aggrement_file"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      aggrement_tmp_file: e.target.files[0],
                    })
                  }
                />
                {formErrors.aggrement_file && (
                  <div className="invalid-feedback d-block">
                    {formErrors.aggrement_file}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button
              type="submit"
              className="btn btn-primary aggrement-copy-submit-btn"
            >
              <i className="fas fa-upload mr-2"></i>
              Upload Agreement
            </button>
          </div>
        </form>
      </div>

      <div className="card aggrement-copy-card aggrement-copy-list-card mt-4">
        <div className="card-header aggrement-copy-header">
          <h3 className="card-title mb-0">Agreement List</h3>
        </div>
        <div className="card-body">
          <MyDataTable
            reloadList={reloadList}
            columns={columns}
            getDataListURL={`getaggrementcopy?entity_id=${formData.entity_id}&entity_type=${formData.entity_type}`}
            setReload={setReload}
            exportName={"aggrementlist"}
          />
        </div>
      </div>
    </div>
  );
};
